import React from 'react'
import { OrderSource } from '../../../interfaces/delivery-company/orders'
import { Box, Chip } from '@mui/material'
import Order from '../../delivery-company-components/order/order'
import { FaFileExcel, FaShopify } from 'react-icons/fa';
import { MdOutlineWebhook } from "react-icons/md";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import WooCommerceIcon from '../woocommerce/icon';


const excelColor = "#63BE7B";
export const shopifyColor = "#96BF48";
const apiIntegrationColor = "rgb(41, 205, 255)";

export const displayOrderSource = (source: OrderSource) => {

  const renderChip = () => {
    if (source === OrderSource.SOURCE_SHOPIFY) return (
        <Chip label={"From Shopify"} variant="filled" icon={<FaShopify size={20} color={shopifyColor}/>} />
      )
    
    if (source === OrderSource.SOURCE_API_INTEGRATION) return (
        <Chip label={"From API Integration"} variant="filled" icon={<MdOutlineWebhook size={20} color={apiIntegrationColor}/>} />
    )

    if (source === OrderSource.SOURCE_EXCEL_IMPORT) return (
        <Chip label={"From Excel Import"} variant="filled" icon={<PiMicrosoftExcelLogoFill size={20} color={excelColor}/>} />
    )

    if (source === OrderSource.SOURCE_WOOCOMMERCE) return (
      <Chip label={"WooCommerce"} variant='filled' icon={<WooCommerceIcon size={32} />} /> 
    )
  }

  const chip = renderChip();

  return chip ? <Box sx={{m:1}}>{chip}</Box> : null;
}   